export default class Qualification {
  constructor(
    datePassed,
    qualificationId,
    objectId,
    parentObjectId,
    parentObjectHistoryId
  ) {
    this.datePassed = datePassed;
    this.qualificationId = qualificationId;
    this.objectId = objectId;
    this.parentObjectId = parentObjectId;
    this.parentObjectHistoryId = parentObjectHistoryId;
  }
}
